import React from 'react';
import './ToastSnippet.css';

const ToastSnippet = () => (
  <pre>
    <code>
      <span class="cn">&lt;button</span>
      <span class="cln"> className="</span><span class="cn">carve-button-main</span><span class="cln">"</span>
      <span class="cln"> data-toast="</span><span class="cn">toastDefault</span><span class="cln">"</span>
      <span class="cln"> onClick={'{'}</span><span class="cn">openToast</span><span class="cln">{'}'}&gt;</span><br />

      &nbsp;&nbsp;<span class="">Open toast</span><br />

      <span class="cn">&lt;/button&gt;</span><br />
      <span className='cn'>&lt;div</span><span className='cln'> class="</span><span className='cn'>carve-toast</span><span className='cln'>"</span><span className='cn'>&gt;</span> <br></br>
      &nbsp;&nbsp; <span>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil, delectus soluta? Veritatis quae voluptas id illo officiis? Cupiditate, consequatur voluptas.</span>
      <br></br><span className='cn'>&lt;/div&gt;</span>
      <br></br>
      <br />

      <span class="cn">&lt;button</span>
      <span class="cln"> className="</span><span class="cn">carve-button-stroke stroke-main</span><span class="cln">"</span>
      <span class="cln"> data-toast="</span><span class="cn">toastRed</span><span class="cln">"</span>
      <span class="cln"> onClick={'{'}</span><span class="cn">openToast</span><span class="cln">{'}'}&gt;</span><br />

      &nbsp;&nbsp;<span class="">Open red toast</span><br />

      <span class="cn">&lt;/button&gt;</span><br />
      <span className='cn'>&lt;div</span><span className='cln'> class="</span><span className='cn'>carve-toast red-toast</span><span className='cln'>"</span><span className='cn'>&gt;</span> <br></br>
      &nbsp;&nbsp; <span>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil, delectus soluta? Veritatis quae voluptas id illo officiis? Cupiditate, consequatur voluptas.</span>
      <br></br><span className='cn'>&lt;/div&gt;</span>
      <br></br>
      <br />

      <span class="cn">&lt;button</span>
      <span class="cln"> className="</span><span class="cn">carve-button-vice</span><span class="cln">"</span>
      <span class="cln"> data-toast="</span><span class="cn">toastGreen</span><span class="cln">"</span>
      <span class="cln"> onClick={'{'}</span><span class="cn">openToast</span><span class="cln">{'}'}&gt;</span><br />

      &nbsp;&nbsp;<span class="">Open green toast</span><br />

      <span class="cn">&lt;/button&gt;</span><br />
      <span className='cn'>&lt;div</span><span className='cln'> class="</span><span className='cn'>carve-toast green-toast</span><span className='cln'>"</span><span className='cn'>&gt;</span> <br></br>
      &nbsp;&nbsp; <span>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil, delectus soluta? Veritatis quae voluptas id illo officiis? Cupiditate, consequatur voluptas.</span>
      <br></br><span className='cn'>&lt;/div&gt;</span>
    </code>

  </pre>
);

ToastSnippet.propTypes = {};

export default ToastSnippet;